// import Vue from 'vue'

export function SET_CMS_PAGE_DETAIL(state, { slugId, pageDetail }) {
  // Vue.set(state.cmsPages, slugId, pageDetail)
  state.cmsPages = {
    ...state.cmsPages,
    [slugId]: pageDetail,
  }
}

export function SET_LOADING(state, loading) {
  state.loading = loading
}
